import React, { useState } from 'react';
import styles from './ProfileDropdown.module.scss';
import right from '../../assets/logo/right.svg';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

const ProfileDropdown = () => {
  const [toggleProfile, setToggleProfile] = useState(false);
  const { user } = useSelector((state) => state.auth);
  const navigate = useNavigate();

  const logOut = () => {
    localStorage.clear();
    navigate('/');
  };

  // Generate initials from user name
  const getInitials = (firstName, lastName) => {
    const first = firstName ? firstName.charAt(0).toUpperCase() : '';
    const last = lastName ? lastName.charAt(0).toUpperCase() : '';
    return first + last;
  };

  const initials = getInitials(user?.firstName, user?.lastName);

  return (
    <div className={styles['profile-dropdown-container']}>
      <div className={styles['profile-info']}>
        <div className={styles['user-avatar']}>
          {initials}
        </div>
        <div className={styles['user-details']}>
          <div className={styles['user-name']}>
            {user?.firstName} {user?.lastName}
          </div>
          <div className={styles['clinic-owner']}>
            Ethel Boyking
          </div>
          <div className={styles['clinic-name']}>
            AOA CLINIC
          </div>
        </div>
        <div 
          className={styles['dropdown-toggle']}
          onClick={() => setToggleProfile(!toggleProfile)}
        >
          <img
            src={right}
            alt="dropdown"
            className={`${styles['dropdown-icon']} ${toggleProfile ? styles['rotated'] : ''}`}
          />
        </div>
      </div>
      
      {toggleProfile && (
        <div className={styles['dropdown-menu']}>
          <div className={styles['dropdown-arrow']}></div>
          <div className={styles['dropdown-content']}>
            <div className={styles['menu-item']} onClick={logOut}>
              Logout
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ProfileDropdown; 